import React from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import {
  EntityType,
  EntityTypesSupportingChildLayouts,
  entityTypesSupportingChildLayouts,
  EntityTypesSupportingFieldCustomization,
} from "@mapmycustomers/shared/types/entity";
import FormLayout from "@mapmycustomers/shared/types/layout/FormLayout";
import { Alert, Button } from "@mapmycustomers/ui";

import { RootState } from "@app/store/rootReducer";

import { getActiveEntityType, getEditedLayout } from "../../store";
import VariantPopover from "../VariantPopover";
import VariantsList from "../VariantsList";

import styles from "./LayoutVariants.module.scss";

interface Props {
  entityType: EntityTypesSupportingFieldCustomization;
  layout?: FormLayout;
}

const messages = defineMessages({
  addVariant: {
    id: "settings.formLayouts.modal.variants.addVariant",
    defaultMessage: "+ Variant",
    description: "Add Variant button title",
  },
  bannerTitle: {
    id: "settings.formLayouts.modal.variants.title",
    defaultMessage: "You are editing a variant",
    description: "Editing variant banner title",
  },
  [EntityType.ACTIVITY]: {
    id: "settings.formLayouts.modal.variants.text.activity",
    defaultMessage: "Change which fields are visible based on Activity Type",
    description: "Variants selector text for activities layouts",
  },
  [EntityType.DEAL]: {
    id: "settings.formLayouts.modal.variants.text.deals",
    defaultMessage: "Change which fields are visible based on Deal Stage",
    description: "Variants selector text for deals layouts",
  },
});

const LayoutVariants: React.FC<Props> = ({ entityType, layout }) => {
  const intl = useIntl();

  const entityTypeCasted = entityType as EntityTypesSupportingChildLayouts;
  const hasChildLayouts = layout?.childLayouts && layout.childLayouts.length > 0;

  if (!entityTypesSupportingChildLayouts.includes(entityTypeCasted)) {
    return null;
  }

  return (
    <div className={styles.container}>
      {hasChildLayouts ? (
        <VariantsList />
      ) : (
        <Alert
          action={
            <VariantPopover>
              <Button className={styles.actionButton}>
                {intl.formatMessage(messages.addVariant)}
              </Button>
            </VariantPopover>
          }
          message={intl.formatMessage(messages[entityTypeCasted])}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  entityType: getActiveEntityType(state),
  layout: getEditedLayout(state),
});

export default connect(mapStateToProps)(LayoutVariants);
